/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type ListType = typeof ListType[keyof typeof ListType];


export const ListType = {
  ORDERED: 'ORDERED',
  UNORDERED: 'UNORDERED',
} as const;
